'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var socialMediaTypes = {
  facebook: 'facebook',
  twitter: 'twitter',
  google: 'google',
  pintrest: 'pintrest',
  instagram: 'instagram'
};

exports.default = socialMediaTypes;


//////////////////
// WEBPACK FOOTER
// ./~/@fishrmn/fishrmn-types/build/types/socialMediaTypes.js
// module id = 518
// module chunks = 168707334958949